/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

export const splitByCommaTrimAndCompact = string => _.compact(string.split(',').map(item => item.trim()));
